import { render, staticRenderFns } from "./AlertComponent.vue?vue&type=template&id=2b66de57&scoped=true&"
import script from "./AlertComponent.vue?vue&type=script&lang=ts&"
export * from "./AlertComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AlertComponent.vue?vue&type=style&index=0&id=2b66de57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b66de57",
  null
  
)

export default component.exports